var _path, _path2, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgTokenError = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 48,
    viewBox: "0 0 60 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.479233 0.861864C1.24592 -0.116136 2.65967 -0.287605 3.63842 0.478989L59.1375 43.9781C60.1125 44.7468 60.2906 46.1624 59.5219 47.1374C58.7531 48.1124 57.3375 48.2906 56.3625 47.5218L0.862108 4.02086C-0.115892 3.25399 -0.287361 1.84024 0.479233 0.861864Z",
    fill: "url(#paint0_linear_155_1894)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M41.1189 29.8499L50.1095 20.8593C53.0626 17.9062 53.0626 13.0406 50.1095 10.1718C47.5033 7.559 43.3783 7.21775 40.3783 9.36557L40.2283 9.46869C38.8783 10.4343 37.0033 10.0406 36.047 8.77307C35.0814 7.42494 35.3908 5.55088 36.7407 4.58807L36.8908 4.48307C42.2814 0.630972 49.6689 1.24213 54.3564 5.92869C59.6533 11.2218 59.6533 19.8093 54.3564 25.0968L45.872 33.5812L41.1189 29.8499ZM33.1314 23.5968C33.6845 21.1406 32.972 18.4874 31.097 16.6124C28.7439 14.2593 25.2282 13.7812 22.322 15.1031L17.4095 11.2781C22.7345 7.10807 30.4407 7.47463 35.2595 12.2906C39.3845 16.4156 40.397 22.4624 38.1283 27.5156L33.1314 23.5968ZM24.6564 35.6249C21.8532 32.8218 20.5032 29.0437 20.7095 25.3124L38.1189 39.0374C33.5064 40.4062 28.3032 39.2718 24.6564 35.6249ZM10.9314 17.6156L15.6751 21.3562L9.89074 27.1406C6.93667 30.0093 6.93667 34.8749 9.89074 37.8281C12.497 40.4437 16.622 40.7812 19.622 38.6343L19.772 38.4468C21.122 37.5656 22.997 37.8749 23.9532 39.2249C24.9189 40.5749 24.6095 42.4499 23.2595 43.4156L23.1095 43.5187C17.6345 47.3718 10.3314 46.7531 5.6448 42.0749C0.350824 36.7781 0.350824 28.1906 5.6448 22.9031L10.9314 17.6156Z",
    fill: "url(#paint1_linear_155_1894)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_155_1894",
    x1: 30.0003,
    y1: -0.000244141,
    x2: 30.0003,
    y2: 48.0005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AA0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D3DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_155_1894",
    x1: 30.0017,
    y1: 1.95752,
    x2: 30.0017,
    y2: 46.0427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AA0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D3DA"
  })))));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgTokenError);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/token-error.be0c62740a182d0d412b78d762370fe7.svg";